// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1_fXi","cls2":"CurrentPaperRow-cls2_CMu CurrentPaperRow-cls1_fXi"};